// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { EnumPipelineHandleStatus } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/EnumPipelineHandleStatus';
import { EnumPipelinePhase } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/EnumPipelinePhase';
import { PipelinePublishTask } from './PipelinePublishTask';
/**
 * 流水线发布阶段 实体类
 * 流水线发布阶段
 */
export class PipelinePublishPhase extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 开始执行时间 : 开始执行时间 */
  private _beginTime: Date;

  /** 设置：开始执行时间 */
  public get beginTime() {
    return this._beginTime;
  }

  /** 获取：开始执行时间 */
  public set beginTime(value: Date) {
    this._beginTime = value;
  }

  /** 结束时间 : 结束时间 */
  private _endTime: Date;

  /** 设置：结束时间 */
  public get endTime() {
    return this._endTime;
  }

  /** 获取：结束时间 */
  public set endTime(value: Date) {
    this._endTime = value;
  }

  /** 执行耗时 : 执行耗时，单位毫秒 */
  private _exeTimeSpan: number;

  /** 设置：执行耗时 */
  public get exeTimeSpan() {
    return this._exeTimeSpan;
  }

  /** 获取：执行耗时 */
  public set exeTimeSpan(value: number) {
    this._exeTimeSpan = value;
  }

  /** 阶段描述 : 阶段描述信息，说明阶段的具体工作 */
  private _description: string;

  /** 设置：阶段描述 */
  public get description() {
    return this._description;
  }

  /** 获取：阶段描述 */
  public set description(value: string) {
    this._description = value;
  }

  /** 错误消息 : 对前端友好的错误消息 */
  private _errorMessage: string;

  /** 设置：错误消息 */
  public get errorMessage() {
    return this._errorMessage;
  }

  /** 获取：错误消息 */
  public set errorMessage(value: string) {
    this._errorMessage = value;
  }

  /** 发布状态 : 发布状态 */
  private _publishStatus: EnumPipelineHandleStatus;

  /** 设置：发布状态 */
  public get publishStatus() {
    return this._publishStatus;
  }

  /** 获取：发布状态 */
  public set publishStatus(value: EnumPipelineHandleStatus) {
    this._publishStatus = value;
  }

  /** 流水线阶段 : 流水线阶段 */
  private _pipelinePhase: EnumPipelinePhase;

  /** 设置：流水线阶段 */
  public get pipelinePhase() {
    return this._pipelinePhase;
  }

  /** 获取：流水线阶段 */
  public set pipelinePhase(value: EnumPipelinePhase) {
    this._pipelinePhase = value;
  }

  /** 阶段唯一标识 : 通过阶段唯一标识，当阶段执行完成以后更新阶段执行状态 */
  private _phaseKey: string;

  /** 设置：阶段唯一标识 */
  public get phaseKey() {
    return this._phaseKey;
  }

  /** 获取：阶段唯一标识 */
  public set phaseKey(value: string) {
    this._phaseKey = value;
  }

  /** 发布任务 的ID */
  private _task_ID: string;

  /** 获取：发布任务 的ID */
  public get task_ID() {
    return this._task_ID;
  }

  /** 设置：发布任务 的ID */
  public set task_ID(value: string) {
    this._task_ID = value;
  }

  /** 发布任务  */
  private _task: PipelinePublishTask;

  /** 获取：发布任务  */
  public get task() {
    return this._task;
  }

  /** 设置：发布任务  */
  public set task(value: PipelinePublishTask) {
    this._task = value;
    if (value !== null) {
      this.task_ID = value.id;
    } else {
      this.task_ID = '';
    }
  }

  /** 主阶段 的ID */
  private _mainPhase_ID: string;

  /** 获取：主阶段 的ID */
  public get mainPhase_ID() {
    return this._mainPhase_ID;
  }

  /** 设置：主阶段 的ID */
  public set mainPhase_ID(value: string) {
    this._mainPhase_ID = value;
  }

  /** 主阶段  */
  private _mainPhase: PipelinePublishPhase;

  /** 获取：主阶段  */
  public get mainPhase() {
    return this._mainPhase;
  }

  /** 设置：主阶段  */
  public set mainPhase(value: PipelinePublishPhase) {
    this._mainPhase = value;
    if (value !== null) {
      this.mainPhase_ID = value.id;
    } else {
      this.mainPhase_ID = '';
    }
  }

  /** 子阶段 */
  private _subPhases: Array<PipelinePublishPhase>;

  /** 获取：子阶段 */
  public get subPhases() {
    return this._subPhases;
  }

  /** 设置：子阶段 */
  public set subPhases(value: Array<PipelinePublishPhase>) {
    this._subPhases = value;
  }

  constructor() {
    super();
    this._name = '';
    this._beginTime = new Date();
    this._endTime = new Date();
    this._exeTimeSpan = 0;
    this._description = '';
    this._errorMessage = '';
    this._publishStatus = EnumPipelineHandleStatus.Padding;
    this._pipelinePhase = EnumPipelinePhase.None;
    this._phaseKey = '';
    this._task_ID = '';
    this._task = null;
    this._mainPhase_ID = '';
    this._mainPhase = null;
    this._subPhases = new Array<PipelinePublishPhase>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: PipelinePublishPhase, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.beginTime = element.beginTime;
      this.endTime = element.endTime;
      this.exeTimeSpan = element.exeTimeSpan;
      this.description = element.description;
      this.errorMessage = element.errorMessage;
      this.publishStatus = element.publishStatus;
      this.pipelinePhase = element.pipelinePhase;
      this.phaseKey = element.phaseKey;
      this.task_ID = element.task_ID;
      if (hasReference && element.task !== null) {
        this.task = element.task;
      }
      this.mainPhase_ID = element.mainPhase_ID;
      if (hasReference && element.mainPhase !== null) {
        this.mainPhase = element.mainPhase;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.beginTime = new Date(json.BeginTime);
    this.endTime = new Date(json.EndTime);
    this.exeTimeSpan = json.ExeTimeSpan;
    this.description = json.Description;
    this.errorMessage = json.ErrorMessage;
    this.publishStatus = json.PublishStatus as EnumPipelineHandleStatus;
    this.pipelinePhase = json.PipelinePhase as EnumPipelinePhase;
    this.phaseKey = json.PhaseKey;
    this.task_ID = json.Task_ID;
    // if (json.Task !== null) {
    //   this.task = PipelinePublishTask.Create(json.Task);
    // }
    this.mainPhase_ID = json.MainPhase_ID;
    // if (json.MainPhase !== null) {
    //   this.mainPhase = PipelinePublishPhase.Create(json.MainPhase);
    // }
    if (json.SubPhases && json.SubPhases.length > 0) {
      json.SubPhases.forEach((element: any) => {
        const pipelinePublishPhase = PipelinePublishPhase.Create(element);
        // pipelinePublishPhase.mainPhase = this;
        this.subPhases.push(pipelinePublishPhase);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.BeginTime = this.beginTime;
    json.EndTime = this.endTime;
    json.ExeTimeSpan = this.exeTimeSpan;
    json.Description = this.description;
    json.ErrorMessage = this.errorMessage;
    json.PublishStatus = this.publishStatus;
    json.PipelinePhase = this.pipelinePhase;
    json.PhaseKey = this.phaseKey;
    json.Task_ID = this.task_ID;
    json.MainPhase_ID = this.mainPhase_ID;
    if (this.subPhases && this.subPhases.length > 0) {
      json.SubPhases = [];
      this.subPhases.forEach((element) => {
        json.SubPhases.push(element.toJson());
      });
    }
  }

  static Create(json: any): PipelinePublishPhase {
    const pipelinePublishPhase = new PipelinePublishPhase();
    pipelinePublishPhase.Deserialize(json);
    pipelinePublishPhase.json = json;
    return pipelinePublishPhase;
  }
}
